module.exports = __webpack_public_path__ + "static/media/icon_phone.411cca1b.svg";